export default {
    getlanguageUserPreferedInCache(state) {
        console.log("state.languageUserPrefered",state.languageUserPrefered)
        return state.languageUserPrefered;
    }
};
